
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('BTN_Print')]),_c('g',[_c('circle',{staticClass:"cls-1",attrs:{"cx":"400","cy":"400","r":"400"}}),_c('g',[_c('path',{staticClass:"cls-2",attrs:{"d":"M505.07,433.53H294.86c-17.26,0-32.06,13.35-32.06,30.55V586.85c0,17.2,14.8,30.62,32.06,30.62H505.07c17.26,0,32.07-13.42,32.07-30.62V464.08C537.14,446.88,522.33,433.53,505.07,433.53ZM317.92,569.2c-15.5,0-15.5-28.62,0-28.62H482c15.56,0,15.56,28.62,0,28.62Zm0-53.84c-15.5,0-15.5-28.63,0-28.63H482c15.56,0,15.56,28.63,0,28.63Z","transform":"translate(0 0)"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M560.76,506.3c23.37,0,43.21,3.53,58-11.21A38.35,38.35,0,0,0,630,468V322.93a38.3,38.3,0,0,0-38.24-38.3H208.25A38.3,38.3,0,0,0,170,322.93V468a38.35,38.35,0,0,0,38.24,38.3h31V454.08c0-30.11,25.39-54.17,55.62-54.17H505.07c30.24,0,55.69,24.06,55.69,54.17ZM515.34,357.87c-15.56,0-15.56-33.56,0-33.56h48.88c15.5,0,15.5,33.56,0,33.56Z","transform":"translate(0 0)"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M284.72,251H515.28V204c0-12.66-12.66-21.48-25.77-21.48H310.42c-13.1,0-25.7,8.82-25.7,21.48Z","transform":"translate(0 0)"}})])])])
          )
        }
      }
    